const ROLES_LIST = {
  GURU: 1,
  WALIKELAS: 2,
  WAKUR: 3,
  KEPSEK: 4,
  ADMIN: 5,
  TATAUSAHA: 6,
  BENDAHARA: 7,
  YAYASAN: 8,
  TENDIK: 9,
};

const getRoleKey = (value) => {
  return Object.keys(ROLES_LIST).find((key) => ROLES_LIST[key] === value);
};

export { getRoleKey };
export default ROLES_LIST;
